import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const GetStartedBox = () => {
  const boxRef = useRef(null);
  const {t} = useTranslation();
  useEffect(() => {
    const element = boxRef.current;

    gsap.fromTo(
      element,
      { scale: 0.7},
      {
        scale: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: element,
          start: "top 80%", // when the top of the element hits 80% of viewport height
          end: "bottom 20%",
          scrub: true, // smooth scrubbing, takes the scroll position into account
        },
      }
    );

    return () => {
      // Clean up ScrollTrigger instances on unmount
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <div className="md:w-theme-container w-mobile-container mx-auto py-20 md:py-30 overflow-hidden rounded-3xl">
      <div ref={boxRef} className="get-started-box rounded-3xl overflow-hidden">
        <div className="w-full rounded-3xl overflow-hidden bg-gradient-to-r from-black to-transparent flex flex-col md:flex-row items-center justify-between p-8 md:p-12 lg:py-44 text-white relative">
          <div className="md:w-1/2 z-10">
            <h2 className="text-3xl md:text-4xl font-bold leading-tight">
              {t('common.transformIdea')} <br />
              {t('common.withOur')} <br />
              Ready In <span className="text-blue-500">90 days</span> or Less!
            </h2>
            <p className="mt-4 text-sm md:text-base">
              {t('common.getStartedDescription')}
            </p>
            <a href="/contact">
              <button className="mt-6 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full flex items-center space-x-2 transition">
                <span>{t('common.contactNow')} !</span>
                <span className="text-lg"> → </span>
              </button>
            </a>
          </div>
          <div className="md:w-1/2 mt-8 md:mt-0 relative">
            {/* Background image is via CSS .get-started-box */}
            <div className="absolute inset-0 bg-gradient-to-l from-black/70 to-transparent rounded-xl"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStartedBox;
